import React from 'react'
import CardButton from './CardButton';

function ProjectsCard({ project }) {
  return (
    <div className="rounded-lg md:w-104 md:h-full lg:w-72 xl:w-80 2xl:w-108 overflow-hidden shadow-lg bg-zinc-900 pb-4 my-4 lg:my-1 xl:my-4">
      <img className="rounded md:w-full" src={ project.image.src } alt={ project.image.alt } />
      <div className="px-6 py-4 my-2">
        <div className="font-bold md:text-lg xl:text-lg lg:text-base mb-2 text-slate-100">{ project.name }</div>
        <p className="text-blue-100 text-sm md:text-base lg:text-sm xl:text-base">
          { project.description }
        </p>
      </div>
      <div className="px-5 pb-2 my-2 flex flex-wrap justify-center items-center">
        {project.technologies.map((tech, index) => (
          <span key={ index } className="inline-block bg-gray-200 rounded-full px-2 py-1 text-xs md:text-sm lg:text-xs xl:text-sm font-semibold text-gray-700 mr-2 mb-2">{ tech }</span>
        ))}
      </div>
      <div className="w-full flex justify-evenly p-2">
        <CardButton source={ project.github } buttonName="Github"/>
        {project.deployLink && <CardButton source={ project.deployLink } buttonName="Website"/>}
      </div>
    </div>
  );
}

export default ProjectsCard;